import React from "react";
import { Badge } from "@chakra-ui/react";
import { RESUME_STATUS_BADGE_MAP } from "../constants/statuses";

const ParseStatusBadge = ({ status }) => {
  const config = RESUME_STATUS_BADGE_MAP[status] || {
    label: status || "Unknown",
    colorScheme: "gray",
  };

  return <Badge colorScheme={config.colorScheme}>{config.label}</Badge>;
};

export default ParseStatusBadge;
